(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guide-page"] && !Shopify.designMode) return;
  try {
    

(function () {

  var guidePages = document.querySelectorAll('.guide-page');

  if (!guidePages.length) return;


  guidePages.forEach(function (root) {

    var links = root.querySelectorAll('[data-toc-link]');
    var targets = root.querySelectorAll('[data-toc-target]');

    if (!links.length || !targets.length) return;


    var observer = new IntersectionObserver(

      function (entries) {

        entries.forEach(function (entry) {

          var id =
            entry.target.getAttribute(
              'data-toc-target'
            );

          var link =
            root.querySelector(
              '[data-target="' + id + '"]'
            );

          if (!link) return;


          if (entry.isIntersecting) {

            links.forEach(function (l) {
              l.classList.remove('is-active');
            });

            link.classList.add('is-active');

          }

        });

      },

      {
        rootMargin: '-40% 0px -50% 0px',
        threshold: 0
      }

    );


    targets.forEach(function (target) {
      observer.observe(target);
    });

  });

})();


  } catch(e) { console.error(e); }
})();
})();
